import { render, staticRenderFns } from "./IrtifakVeyaIntifaHakkininKaldirilmasiAlacakFormWizard.vue?vue&type=template&id=cbed156e"
import script from "./IrtifakVeyaIntifaHakkininKaldirilmasiAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./IrtifakVeyaIntifaHakkininKaldirilmasiAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports